/*
 * anok-accordion.js
 *
 * 滑らかな開閉アニメーション付きアコーディオン共通ユーティリティ。
 * scrollHeight を実測して max-height で transition する。
 *
 * Pattern A: <button aria-expanded>/<div hidden>
 *   AnokAccordion.bindButton({ trigger: btn, body: div });
 *
 * Pattern B: <details>/<summary>
 *   AnokAccordion.bindDetails(detailsEl, { body: bodyEl });
 *
 * 仕様:
 *   - 展開: 300ms ease-out
 *   - 収縮: 250ms ease-in
 *   - 連打防止: アニメーション中のクリックは無視
 */
(function () {
  'use strict';

  var OPEN_MS = 300;
  var CLOSE_MS = 250;

  function rAF(fn) {
    return (typeof requestAnimationFrame !== 'undefined')
      ? requestAnimationFrame(fn)
      : setTimeout(fn, 16);
  }

  function open(body, onDone) {
    body.style.transition = '';
    body.style.maxHeight = '0px';
    // force reflow
    body.offsetHeight;
    var target = body.scrollHeight;
    body.style.transition = 'max-height ' + OPEN_MS + 'ms ease-out';
    rAF(function () {
      body.style.maxHeight = target + 'px';
    });
    var done = function () {
      body.removeEventListener('transitionend', done);
      body.style.transition = '';
      body.style.maxHeight = 'none';
      if (onDone) onDone();
    };
    body.addEventListener('transitionend', done);
  }

  function close(body, onDone) {
    var current = body.scrollHeight;
    body.style.transition = '';
    body.style.maxHeight = current + 'px';
    body.offsetHeight;
    body.style.transition = 'max-height ' + CLOSE_MS + 'ms ease-in';
    rAF(function () {
      body.style.maxHeight = '0px';
    });
    var done = function () {
      body.removeEventListener('transitionend', done);
      body.style.transition = '';
      body.style.maxHeight = '';
      if (onDone) onDone();
    };
    body.addEventListener('transitionend', done);
  }

  function bindButton(opts) {
    var trigger = opts.trigger;
    var body = opts.body;
    if (!trigger || !body) return;

    var locked = false;
    if (trigger.getAttribute('aria-expanded') === 'true') {
      body.style.maxHeight = 'none';
    }

    trigger.addEventListener('click', function () {
      if (locked) return;
      var nowOpen = trigger.getAttribute('aria-expanded') === 'true';
      locked = true;
      if (nowOpen) {
        // close: aria-expanded を先に false にして icon の回転と高さの収縮を同期
        trigger.setAttribute('aria-expanded', 'false');
        close(body, function () {
          body.hidden = true;
          locked = false;
        });
      } else {
        // open
        body.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        open(body, function () {
          locked = false;
        });
      }
    });
  }

  function bindDetails(details, opts) {
    var summary = details.querySelector('summary');
    var body = (opts && opts.body) || details.querySelector('[data-accordion-body]');
    if (!summary || !body) return;

    var locked = false;
    // 初期状態: data-state="open|closed" をセット（CSS から icon 等の timing 制御用）
    details.setAttribute('data-state', details.open ? 'open' : 'closed');
    if (details.open) body.style.maxHeight = 'none';

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (locked) return;
      locked = true;
      if (details.open) {
        // close: data-state を先に 'closing' に変更して icon の回転と body の collapse を同期
        details.setAttribute('data-state', 'closing');
        close(body, function () {
          details.removeAttribute('open');
          details.setAttribute('data-state', 'closed');
          locked = false;
        });
      } else {
        details.setAttribute('open', '');
        details.setAttribute('data-state', 'opening');
        open(body, function () {
          details.setAttribute('data-state', 'open');
          locked = false;
        });
      }
    });
  }

  window.AnokAccordion = {
    bindButton: bindButton,
    bindDetails: bindDetails,
    OPEN_MS: OPEN_MS,
    CLOSE_MS: CLOSE_MS
  };
})();
